export const xxxxl = {
  lineHeight: '104px',
  size: '95px',
  lineHeightMobile: '104px',
  sizeMobile: '95px',
  spacing: '0px',
};

export const xxxl = {
  lineHeight: '80px',
  size: '67.773px',
  lineHeightMobile: '80px',
  sizeMobile: '67.773px',
  spacing: '0px',
};

export const xxl = {
  lineHeight: '72px',
  size: '58.714px',
  lineHeightMobile: '72px',
  sizeMobile: '58.714px',
  spacing: '0px',
};

export const xl = {
  lineHeight: '48px',
  size: '41.887px',
  lineHeightMobile: '48px',
  sizeMobile: '41.887px',
  spacing: '0px',
};

export const l = {
  lineHeight: '48px',
  size: '36.288px',
  lineHeightMobile: '32px',
  sizeMobile: '25.888px',
  spacing: '0.2px',
};

export const m = {
  lineHeight: '32px',
  size: '25.888px',
  lineHeightMobile: '32px',
  sizeMobile: '25.888px',
  spacing: '0px',
};

export const s = {
  lineHeight: '32px',
  size: '22.428px',
  lineHeightMobile: '24px',
  sizeMobile: '16px',
  spacing: '0px',
};

export const def = {
  lineHeight: '24px',
  size: '16px',
  lineHeightMobile: '24px',
  sizeMobile: '16px',
  spacing: '0px',
};

export const xs = {
  lineHeight: '24px',
  size: '14px',
  lineHeightMobile: '24px',
  sizeMobile: '14px',
  spacing: '0px',
};

export const xxs = {
  lineHeight: '14px',
  size: '9.889px',
  lineHeightMobile: '14px',
  sizeMobile: '9.889px',
  spacing: '0.2px',
};
